import { createStyles, Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        box: {
            display: "flex",
            flexFlow: "row nowrap",
            justifyContent: "flex-start",
            alignItems: "center",
        },
        circularProgress: {
            color: theme.palette.primary.main,
        },
        badge: {
            color: theme.palette.common.white,
            backgroundColor: theme.palette.primary.main,
        },
    })
);

export default useStyles;
